import React from "react";
import { Container, Form, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import {
  FetchDataDeletionRequestList,
  DeleteAccountRecord,
} from "../../services/consentService";
import { useState, useEffect, useRef } from "react";
import { toast } from "react-toastify";
import moment from "moment";
import action1 from "../../assets/images/icon/action_1.svg";
import right_arrow from "../../assets/images/icon/right-arrow-table.svg";
import delete_icon from "../../assets/images/icon/delete.svg";
import edit_icon from "../../assets/images/icon/edit.svg";
import serach_icon from "../../assets/images/icon/search-icon.svg";
import { decryptDataFromArray } from "helpers/EncDec";
import { generateMaskedPII, getCompanyTimezoneDateTime } from "helpers/utils";
import { useTranslation } from "react-i18next";
import arrow_btn from "../../assets/images/icon/arrow-btn.svg";

function DataDeletionRequestList(props) {
  const { t } = useTranslation();
  const [requestData, setRequestData] = useState([]);
  const [successMessage, setSuccessMessage] = useState("");
  const [error, setError] = useState("");
  const [query, setQuery] = useState("");

  //tabs
  const [activeTab, setActiveTab] = useState("tab1");
  const handleTabClick = tab => {
    setActiveTab(tab);
  };

  useEffect(() => {
    FetchDataDeletionRequestList()
      .then(res => {
        let responseData = res?.data;
        responseData = decryptDataFromArray(responseData);

        if (responseData?.status) {
          setRequestData(responseData?.data);
        } else {
          toast.error(t(`Account Deletion.No Data Available`));
        }
      })
      .catch(err => {
        toast.error(t(`Account Deletion.No Data Available`));
      });
  }, []);

  // Bootstrap table columns
  const handleCheck = (e, app_id) => {
    let value = e.target.checked;
    let allRequest = requestData?.map(el => {
      if (el?.cookie_id === app_id) {
        el.checked = value;
      }
      return el;
    });
    setRequestData(allRequest);
  };

  const columns = [
    /*{
      dataField: "user_id",
      text: "Appl. No",
      classes: "total",
      formatter: (cellContent, row) => {
        const applyDate = new Date(row.apply_date);
        const formattedDate =
          row.appl_id +
          "/" +
          (applyDate.getMonth() + 1) +
          "" +
          applyDate.getFullYear();
        return (
          <div className="date-tabel">
            <input
              defaultChecked={row?.checked || false}
              onClick={e => handleCheck(e, row?.appl_id)}
              type="checkbox"
            />
            <label>{formattedDate}</label>
          </div>
        );
      },
    },*/
    {
      dataField: "job_user.name",
      text: t(`Account Deletion.Name`),
      classes: "application-name ",
    },
    {
      dataField: "email_id",
      text: t(`Account Deletion.Email Id`),
      classes: "application-email ",
      formatter: (cell, row) => <>{generateMaskedPII(row?.email_id)}</>,
    },
    {
      dataField: "job_user.mobile",
      text: t(`Account Deletion.Mobile No`),
      classes: "application-normal",
      formatter: (cell, row) => (
        <>{generateMaskedPII(row?.job_user?.mobile, 2)}</>
      ),
    },
    {
      dataField: "job_user.gender",
      text: t(`Account Deletion.Gender`),
      classes: "application-normal",
    },
    {
      dataField: "created",
      text: t(`Account Deletion.Submitted On`),
      classes: "text-center",
      headerClasses: "text-center ",
      formatter: cell => {
        return moment(getCompanyTimezoneDateTime(cell))?.format(
          "DD MMM YYYY hh:mm:ss a"
        );
      },
    },
    {
      dataField: "deletedAt",
      text: t(`Account Deletion.Deleted On`),
      classes: "text-center",
      headerClasses: "text-center ",
      formatter: cell => {
        return cell
          ? moment(getCompanyTimezoneDateTime(cell)).format(
              "DD MMM YYYY hh:mm:ss a"
            )
          : "Not Deleted";
      },
    },
    {
      dataField: "",
      text: t(`Account Deletion.Actions`),
      formatter: (cell, row) => {
        let user_id = row.user_id;
        let status = row.status;

        return (
          <div className="d-flex gap-1 blue-icon-gap action-application">
            {status == 1 ? (
              <div className="action-one small-img">
                <div
                  className="text-success blue-icon blue-color4"
                  to="#"
                  title="Done"
                >
                  <img src={edit_icon} alt="edit_icon" />
                  <span>{t(`Account Deletion.Done`)}</span>
                </div>
              </div>
            ) : (
              <div className="action-one small-img">
                <div
                  onClick={() => handleAccountRecords(user_id)}
                  className="text-success blue-icon  blue-color3"
                  style={{ cursor: "pointer" }}
                  to="#"
                  title="Delete"
                >
                  <img src={delete_icon} alt="delete_icon" />
                  <span>{t(`Account Deletion.Delete`)}</span>
                </div>
              </div>
            )}
          </div>
        );
      },
    },
    // Add more columns as needed
  ];
  const customTotal = (from, to, size) => (
    <span className="react-bootstrap-table-pagination-total">
      {t(`Account Deletion.Showing rows`, { from, to, size })}
    </span>
  );
  let options = {
    paginationSize: 1,
    pageStartIndex: 1,
    alwaysShowAllBtns: true, // Always show next and previous button
    withFirstAndLast: true, // Hide the going to First and Last page button
    hideSizePerPage: true, // Hide the sizePerPage dropdown always
    hidePageListOnlyOnePage: true, // Hide the pagination list when only one page
    firstPageText: false,
    prePageText: false,
    nextPageText: false,
    lastPageText: false,
    nextPageTitle: "First page",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
    paginationTotalRenderer: customTotal,
    disablePageTitle: false,
  };
  // Delete Faqs
  const handleAccountRecords = franchise_id => {
    DeleteAccountRecord(franchise_id)
      .then(res => {
        if (res.status == 200) {
          let messages = toast.success(
            t(`Account Deletion.Record deleted successfully`)
          );
          window.location.reload();
        } else {
          toast.error(res?.data?.message);
          ref.current?.scrollIntoView({ behavior: "smooth" });
        }
      })
      .catch(error => {
        console.log(error);
      });
  };

  //rohit-code//
  const renderCheck = item => {
    let searchableText = JSON.stringify(item)?.toLowerCase();
    if (searchableText?.includes(query?.toLowerCase())) {
      return true;
    }
    return false;
  };

  const rowClasses = (row, rowIndex) => {
    return rowIndex % 2 === 0 ? "even-row" : "odd-row";
  };

  /**table arrow */
  const tableWrapperRef = useRef(null);
  const handleScroll = direction => {
    if (tableWrapperRef.current) {
      const scrollAmount = 100; // Adjust this value as needed
      tableWrapperRef.current.scrollBy({
        left: direction === "left" ? -scrollAmount : scrollAmount,
        behavior: "smooth",
      });
    }
  };

  useEffect(() => {
    const theme = localStorage.getItem("company_theme");
    if (theme) {
      document.body.classList.add(`theme-${theme}`);
    }
  }, []);

  return (
    <>
      <div className="page-content departmentpage pb-1">
        <div className="joblist-container create-vacancy">
          <Row className="mb-1 align-items-center">
            <Col lg="6" md="6" className="Joblist-column">
              <Link to="/dashboard">
                <h5 className="text-uppercase heading-one">
                  <img src={arrow_btn} alt="arrow_btn" />
                  Cookies List
                </h5>
              </Link>
            </Col>
          </Row>
        </div>
        <div className="outerTab-box-wrapper below-vacancy amsterresign applicationcard-table pt-2">
          <div className="franchise-list-page">
            <div className="tab-content" id="pills-tabContent">
              <div
                className="tab-pane fade show active"
                id="pills-home"
                role="tabpanel"
                // aria-labelledby="pills-home-tab"
              >
                <div className="tabel-application table-responsive pb-3">
                  <div className="tabel-franchise table-responsive pb-3">
                    <div className="table-data-search">
                      <div className="total-record">
                        <h5>
                          {t(`Account Deletion.Total Records`)}:{" "}
                          <span>{requestData?.length || 0}</span>
                        </h5>
                      </div>
                      <div className="total-serachbar cookieslist">
                        <div className="serach-bar-top">
                          <form className="form-inline">
                            <input
                              className="form-control mr-sm-2"
                              type="search"
                              placeholder={t(`Account Deletion.Search By`)}
                              aria-label="Search"
                              onChange={e => setQuery(e.target.value)}
                              title={t(`Account Deletion.Search By`)}
                            />
                            <span>
                              <img src={serach_icon} alt="search" />
                            </span>
                          </form>
                        </div>
                        <div className="tale-text right-panel">
                          <button
                            className="button left"
                            onClick={() => handleScroll("left")}
                            data-tooltip={t(`Account Deletion.Scroll Left`)}
                          >
                            <img src={right_arrow} alt="right-arrow" />
                          </button>
                          <button
                            className="button right"
                            onClick={() => handleScroll("right")}
                            data-tooltip={t(`Account Deletion.Scroll Right`)}
                          >
                            <img src={right_arrow} alt="right-arrow" />
                          </button>
                        </div>
                      </div>
                    </div>

                    <div className="tabel-application table-responsive white-space-row  pb-3">
                      <div className="timeto-hire-card userlist">
                        <div className="table-custome-class range-custome">
                          <div className="scroll-container">
                            <div className="table-pending-list">
                              <div
                                className="table-wrapper"
                                ref={tableWrapperRef}
                              >
                                <BootstrapTable
                                  keyField="id"
                                  data={requestData?.filter(renderCheck)}
                                  columns={columns}
                                  pagination={paginationFactory(options)}
                                  rowClasses={rowClasses}
                                  hover
                                  responsive
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default DataDeletionRequestList;
